module.exports = __webpack_public_path__ + "static/media/DuplicateSlab-Italic.a3626271.woff2";